<template>
  <footer :class="['footer',  _isMobile()?'mobile':'']">
    <a-row type="flex" justify="space-between" class="footer1">
      <a-col :xs="24" :sm="12" :md="4" :lg="4" :xl="4">
        <img class="logo" :src="tenantInfo && tenantInfo.logo ? tenantInfo.logo : '/img/logo.png'" alt=""/>
      </a-col>
      <a-col :xs="0" :sm="12" :md="20" :lg="20" :xl="20">
        <a-row class="footer-menu">
          <a-col v-for="(m1, i) in menus" :key="i" :xs="6" :sm="6" :md="4" :lg="3" :xl="3">
            <h3><a :href="m1.url">{{m1.title}}</a></h3>
            <h4 v-for="(m2,j) in m1.children" :key="j"><a :href="m2.url">{{m2.title}}</a></h4>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <div class="footer2">
      <div class="logoList" style="font-family: Arial, 'Microsoft Yahei', 'Helvetica Neue', Helvetica, sans-serif; font-size: 16px;" data-v-efc58504="">
        <div class="logoList" style="text-align: start;" data-v-efc58504="">
        <ul class="cyscc_footer_main" style="margin: 0px auto; padding: 0px; list-style: none; overflow: hidden; position: relative; line-height: 90px; text-align: center;" data-v-efc58504="">
        <li style="cursor: auto; display: inline-block; margin: 0px 30px;" data-v-efc58504=""><img class="cyscclogo cyscclogo" style="border: 0px; vertical-align: middle; height: 52px;" src="https://cyscc.org/img/%E9%A1%B5%E5%BA%95logo2@2x.png" data-v-efc58504="" /></li>
        <li style="cursor: pointer; display: inline-block; margin: 0px 30px;" data-v-efc58504=""><a style="outline: none 0px; border: none; text-decoration-line: none; color: #25a4bb;" href="http://www.cacsi.org.cn/" target="_blank" rel="noopener" data-v-efc58504=""><img class="cyscclogo cyscclogo" style="border: 0px; vertical-align: middle; height: 52px;" src="https://cyscc.org/img/logo-cacsi.png" data-v-efc58504="" /></a></li>
        <li style="cursor: pointer; display: inline-block; margin: 0px 30px;" data-v-efc58504=""><a style="outline: none 0px; border: none; text-decoration-line: none; color: #25a4bb;" href="https://www.kepuchina.cn/" target="_blank" rel="noopener" data-v-efc58504=""><img class="cyscclogo2 cyscclogo" style="border: 0px; vertical-align: middle; height: 52px;" src="https://cyscc.org/img/%E9%A1%B5%E5%BA%95logo4@2x.png" data-v-efc58504="" /></a></li>
        </ul>
        </div>
      </div>
      <!-- <hr> -->
      <!-- <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备12019928号-2</a> -->
    </div>
  </footer>
</template>
<script>
import Vue from "vue";
import { TENANT_CONFIG } from "@/store/mutation-types";
import {mixinDevice} from '@/utils/mixin.js'

export default {
  name: "Footer",
  mixins: [mixinDevice],
  data() {
    return {
      year: new Date().getFullYear(),
      tenantInfo: {},
      menus: [],
      isLogin: false
    };
  },
  created() {
    this.tenantInfo = this.$store.getters.tenantInfo
    this.isLogin = this.$store.getters.userInfo != null;
    this.menus = this.$store.getters.menuList
    console.log(this.menus);
  },
};
</script>
<style lang="less" scoped>
.mobile{
  // padding-left:25px;
  // padding-right:25px;
  // height: 120px!important;
}
footer {
  background: #3e365d87;
  color: white;
  width: 100%;
  min-height: 90px;
  bottom:0;
  text-align: center;
}
.logo{
  width: 100px;
}
.footer1{
  background:rgb(1,19,58);
  padding: 20px;
}
.footer2{
  background: rgb(9,26,66)
}
.footer-menu{
  a{
    color:white;
  }
}
</style>